import React, { useState } from "react";
import MapDemoContext from "./map-demo-Context";

function MapDemoProvider(props) {
  const [address, setAddress] = useState("");
  const [destinations, setDestinations] = useState([]);
  const [routes, setRoutes] = useState({});
  const [location, setLocation] = useState({
    lat: "",
    lng: "",
  });
  const [apiKey, setApiKey] = useState("");
  const [page, setPage] = useState("DemoIntro");
  const [markers, setMarkers] = useState([]);
  const [centerMarker, setCenterMarker] = useState([]);
  const [centerCoordinate, setCenterCoordinate] = useState({});
  const [name, setName] = useState([]);
  const [time, setTime] = useState("00:00:00");
  const [addressId, setAddressId] = useState(0);
  const [inputMethod, setInputMethod] = useState("روش انتخاب نقاط");
  const [demo, setDemo] = useState("");
  const [env, setEnv] = useState("");
  const [fleet, setFleet] = useState([]);
  // which point is selected as source for tsp/vrp
  const [selectedSourceIndex, setSelectedSourceIndex] = useState([]);
  // massage text, img and type
  const [message, setMessage] = useState(
    {
    text: 'پیام‌های شما اینجا نمایش داده می‌شود.',
    type: 'default'
  })

  return (
    <MapDemoContext.Provider
      value={{
        address: address,
        updateAddress: (address) => setAddress(address),
        markers: markers,
        updateMarkers: (markers) => setMarkers(markers),
        centerMarker: centerMarker,
        updateCenterMarker: (centerMarker) => setCenterMarker(centerMarker),
        centerCoordinate: centerCoordinate,
        updateCenterCoordinate: (centerCoordinate) =>
          setCenterCoordinate(centerCoordinate),
        destinations: destinations,
        updateDestinations: (destinations) => setDestinations(destinations),
        location: location,
        updateLocation: (location) => setLocation(location),
        name: name,
        updateName: (name) => setName(name),
        time: time,
        setTime: (time) => setTime(time),
        addressId: addressId,
        updateAddressId: (id) =>
          id !== undefined ? setAddressId(id) : setAddressId(addressId + 1),
        routes: routes,
        drawRoutes: (routes) => setRoutes(routes),
        apiKey: apiKey,
        setApiKey: (apiKey) => setApiKey(apiKey),
        page: page,
        setPage: (page) => setPage(page),
        inputMethod: inputMethod,
        updateInputMethod: (inputMethod) => setInputMethod(inputMethod),
        demo: demo,
        setDemo: (demoName) => setDemo(demoName),
        fleet,
        setFleet: (fleetItems) => setFleet(fleetItems),
        selectedSourceIndex,
        setSelectedSourceIndex,
        env,
        setEnv,
        message,
        setMessage
      }}
    >
      {props.children}
    </MapDemoContext.Provider>
  );
}

export default MapDemoProvider;
